import { Subject } from 'rxjs';
let channels = new Map();
channels.set('default', new Subject());
const getChannelMap = () => {
    if (typeof window !== 'undefined') {
        if (!window.AperzaReactiveMessageChannel) {
            window.AperzaReactiveMessageChannel = new Map();
            window.AperzaReactiveMessageChannel.set('default', new Subject());
        }
        return window.AperzaReactiveMessageChannel;
    }
    else {
        return channels;
    }
};
const getChannel = (channel = 'default') => {
    let channelMap = getChannelMap();
    if (channelMap) {
        if (channelMap.has(channel)) {
            return channelMap.get(channel);
        }
        else {
            console.warn(`useReactiveMessage. Channel: ${channel} is not found!`);
        }
    }
    else {
        console.warn(`useReactiveMessage. ChannelMap is not found!`);
    }
};
export const useReactiveMessage = (channel = 'default') => {
    let c = getChannel(channel);
    if (!c) {
        let channelMap = getChannelMap();
        if (channelMap) {
            channelMap.set(channel, new Subject());
        }
    }
    return {
        sendMessage: (message, _channel) => {
            let c = getChannel(_channel ? _channel : channel);
            if (c)
                c.next({ ...message });
        },
        clearMessages: (_channel) => {
            let c = getChannel(_channel ? _channel : channel);
            if (c)
                c.next();
        },
        getMessage: (_channel) => {
            let c = getChannel(_channel ? _channel : channel);
            if (c)
                return c.asObservable();
        },
    };
};
